const formatModelName = (modelName: string) => {
  const distructedModelName = modelName.split(' ');
  const [year, ...model] = distructedModelName;
  return `${year} Audi ${model.join(' ')}`;
};

export default formatModelName;
